import React from "react";
import { Facebook, Instagram, Youtube } from "lucide-react";
import { KD9_SOCIALS } from "@/lib/contact";

const TikTokIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M15.2 3c.4 2.2 1.7 3.5 3.8 3.7v3.1a8.1 8.1 0 0 1-3.8-1.1v6.1a6 6 0 1 1-5.1-5.9v3.2a2.9 2.9 0 1 0 2 2.7V3h3.1Z" fill="currentColor"/>
  </svg>
);

const ICONS = {
  instagram: Instagram,
  tiktok: TikTokIcon,
  youtube: Youtube,
  facebook: Facebook,
};

const SocialLinks = ({ testIdPrefix = "social-link", className = "" }) => (
  <div className={`flex flex-wrap gap-3 ${className}`}>
    {KD9_SOCIALS.map((social) => {
      const Icon = ICONS[social.key];
      return (
        <a
          key={social.key}
          href={social.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Abrir ${social.label} de Khaos Delta 9`}
          title={social.label}
          data-testid={`${testIdPrefix}-${social.key}`}
          className="w-11 h-11 rounded-full flex items-center justify-center border transition-all hover:-translate-y-0.5 hover:border-[color:var(--kd9-accent)]"
          style={{ borderColor: "var(--kd9-border)", color: "var(--kd9-accent)" }}
        >
          <Icon size={17} />
        </a>
      );
    })}
  </div>
);

export default SocialLinks;
